import { CancelTokenSource } from 'axios'
import { apPrecios } from './bff/bffClient';

/**
 * Paso 2 AP: obtiene precios vía el BFF (POST {BFF}/ap/precios).
 * El BFF devuelve un ARRAY de coberturas. Lo adaptamos al envelope
 * { data: { api_status, api_data } } que consume la página de Precios AP.
 * El recaptcha lo mintea el bffClient (header `g-recaptcha-response`), por eso
 * `captchaToken` ya no se usa. `cancelTokenSource` se mantiene por compatibilidad de firma.
 */
const cotizarAP = async (
    compania: string,
    idContacto: string,
    emisionHabilitada: string,
    token: string,
    _cancelTokenSource: CancelTokenSource,
    _captchaToken?: string
): Promise<any> => {
    try {
        const apiData = await apPrecios({
            compania,
            idContacto,
            token,
            emisionHabilitada,
        });
        return { data: { api_status: 200, api_data: apiData } };
    } catch (error) {
        console.error('Error en la solicitud', error);
        return error;
    }
};

export default cotizarAP;
